module.exports = __webpack_public_path__ + "static/media/Mobile-DJ_AV.d9ae736a.jpg";